import React from 'react';
import { Smartphone, Siren, ClipboardCheck, MessageCircle, Award, Headphones } from 'lucide-react';
export function AdvancedModulesSlide() {
  const modules = [{
    title: 'Driver Mobile App',
    icon: Smartphone,
    points: ['UAE Pass login & onboarding', 'Compliance tracking & document management', 'Notifications and alerts']
  }, {
    title: 'Emergency & Roadside',
    icon: Siren,
    points: ['Accident & breakdown requests', 'Media and voice reporting', 'Real-time integration with Sheel']
  }, {
    title: 'Passing Centers',
    icon: ClipboardCheck,
    points: ['Booking & scheduling inspections', 'Permit uploads & verification', 'Lifecycle tracking']
  }, {
    title: 'WhatsApp Automation',
    icon: MessageCircle,
    points: ['Service booking & check-in', 'Voice interaction', 'Driver eligibility validation']
  }, {
    title: 'Rewards, Wallet & Ratings',
    icon: Award,
    points: ['Incentives and performance tracking', 'Wallet transactions', 'Driver feedback system']
  }, {
    title: 'Support & Ticketing',
    icon: Headphones,
    points: ['Full helpdesk system', 'SLA management', 'Communication & tracking']
  }];
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] px-8 py-6" data-id="element-26">
      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0" data-id="element-27">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-8 w-auto object-contain" data-id="element-28" />
      </div>

      {/* Title */}
      <div className="text-center shrink-0 mb-6 mt-2" data-id="element-29">
        <span className="text-xs font-semibold text-[#2EBCB0] uppercase tracking-widest" data-id="element-30">
          Advanced Operations
        </span>
        <h1 className="text-[1.25rem] font-bold text-[#1a1a2e] mt-1" data-id="element-31">
          Advanced Operations & User Experience Modules
        </h1>
      </div>

      {/* Main Grid */}
      <div className="flex-grow flex items-center justify-center w-full max-w-7xl mx-auto" data-id="element-32">
        <div className="grid grid-cols-3 gap-5 w-full" data-id="element-33">
          {modules.map((mod, idx) => <div key={idx} className="bg-gray-50/50 border border-gray-100 rounded-xl p-5 flex flex-col hover:shadow-md transition-shadow duration-300" data-id="element-34">
              <div className="flex items-center gap-3 mb-4" data-id="element-35">
                <div className="w-10 h-10 rounded-lg bg-[#2EBCB0]/10 text-[#2EBCB0] flex items-center justify-center shrink-0" data-id="element-36">
                  <mod.icon className="w-5 h-5" data-id="element-37" />
                </div>
                <h3 className="font-bold text-[0.85rem] text-[#1a1a2e] leading-tight" data-id="element-38">
                  {mod.title}
                </h3>
              </div>
              <ul className="space-y-2.5 mt-auto" data-id="element-39">
                {mod.points.map((point, pIdx) => <li key={pIdx} className="flex items-start gap-2" data-id="element-40">
                    <div className="w-1.5 h-1.5 rounded-full bg-[#2EBCB0] mt-1.5 shrink-0" data-id="element-41" />
                    <span className="text-[0.75rem] text-gray-600 leading-snug" data-id="element-42">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>

      {/* Bottom Tagline */}
      <div className="text-center shrink-0 mt-4" data-id="element-43">
        <p className="text-[0.75rem] italic text-gray-400" data-id="element-44">
          "Enhancing driver experience, automation, and operational efficiency."
        </p>
      </div>
    </div>;
}